
export const SMALL_DIALOG_WIDTH = "350px";  // 40%
export const MEDIUM_DIALOG_WIDTH = "500px"; // 60%
export const LARGE_DIALOG_WIDTH = "900px" // 85%